import { useQuery } from '@apollo/client'

import { listOrderExportTasksDocument } from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

atlas`#graphql
  query listOrderExportTasks($input: ListOrderExportTasksInput!) {
    listOrderExportTasks(input: $input) {
     exportTasks {
        id
        status
        downloadUrl
     }
    }
  }
`

export function useListOrderExportTasks(tasksIds: string[]) {
  const { data, loading, startPolling, stopPolling } = useQuery(
    listOrderExportTasksDocument,
    {
      client: atlasClient,
      variables: {
        input: { ids: tasksIds },
      },
      skip: !tasksIds,
    },
  )

  return { data, loading, startPolling, stopPolling }
}
